import styled from 'styled-components'
import { COLORS } from 'consts/colors'

interface IDropdownButtonWrapperProps {
  $isOpen: boolean
  $disabled: boolean
}

interface IArrowWrapperProps {
  $isOpen: boolean
}

export const DropdownButtonWrapper = styled.div<IDropdownButtonWrapperProps>`
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 4px;
  border: ${props =>
    `1px solid ${props.$isOpen ? COLORS.primaryDark : COLORS.borderColor}`};
  background: ${COLORS.white};
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.$disabled ? 0.5 : 1)};
  transition: all 0.3s;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;

  &:hover {
    border: ${props =>
      !props.$isOpen && `1px solid ${COLORS.secondarySemiLight}`};

    &:before {
      content: ' ';
      position: absolute;
      z-index: -1;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border: 1px solid rgba(56, 125, 255, 0.16);
      border-radius: 5px;
    }
  }
`

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`

export const ArrowWrapper = styled.div<IArrowWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-in-out;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  margin-left: 8px;

  svg {
    width: 12px;
    height: 12px;
    color: ${COLORS.secondaryExtraDark};
  }
`
